import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import storageService from "../../utils/storageService";

const decodeToken = (token) => {
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return {
      ...decoded,
    };
  } catch (error) {
    return null;
  }
};

const token = storageService.getItem("Token");
const decodedUser = decodeToken(token);

const initialState = {
  token: token || null,
  isAuthenticated: !!token,
  user: decodedUser,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token } = action.payload;

      const decodedUser = decodeToken(token);
      console.log("decodedUser: ", decodedUser);

      state.token = token;
      state.isAuthenticated = !!token;
      state.user = decodedUser;
    },

    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
      state.guestToken = null;
      storageService.clear();
      sessionStorage.setItem(
        "wasLoggedOut",
        "true"
      );
    },
    setGuestToken: (state, action) => {
      state.guestToken = action.payload;
    },
  },
});

export const {
  setCredentials,
  logout,
  setGuestToken,
} = authSlice.actions;



export default authSlice.reducer;